import { NUMBER_SIZE } from '../../../constants/size'
import { FileIconPreview } from '../../FileIcon'
import { FloatingTooltip } from '../../Floating'
import { ProgressBar } from '../../ProgressBar'

import * as styles from './FilesListUploadingItem.module.css'

function FilesListUploadingItem({ file }) {
  return (
    <FloatingTooltip content={file.name}>
      <div className={styles.FilesListUploadingItem}>
        <FileIconPreview file={file} size={NUMBER_SIZE.size40} />
        <ProgressBar className={styles.progress} />
      </div>
    </FloatingTooltip>
  )
}

export default FilesListUploadingItem
